import { createContext } from 'react';

export interface IRootDynamicDataContextValue {
  isLinearHybridAdShowed: boolean;
  userId: number;
}

export const RootDynamicDataContext =
  createContext<IRootDynamicDataContextValue>({
    isLinearHybridAdShowed: false,
    userId: 0,
  });
